import { styled } from 'styled-components';

import { Modal } from '@/app/shared/ui/Modal';
import { DocumentPreview } from './DocumentPreview';
import type { DocumentItem, IStip } from './stips.types';

export const ModalWrapper = styled.div`
  padding: 10px 15px;
`;

export interface IDocumentPreviewModalProps {
    open: boolean;
    documentPreviewModalPosition: number;
    contactStipData: DocumentItem;
    stipData: IStip;
    onClose: () => void;
}

export const DocumentPreviewModal = ({ open, documentPreviewModalPosition, contactStipData, stipData, onClose }: IDocumentPreviewModalProps) => (
    <Modal
        hideBackdrop
        title="Document Preview"
        open={open}
        resetPosition={documentPreviewModalPosition}
        dialogHeight="80vh"
        onClose={onClose}
    >
        <ModalWrapper style={{ paddingRight: 0 }}>
            <DocumentPreview contactStipData={contactStipData} stipData={stipData} />
        </ModalWrapper>
    </Modal>
);

